export function warn(msg) {
  const txt = msg.toString()
  if (process.env.NODE_ENV === 'development') {
    return console.warn(`[yxswy] ${txt}`)
  }
}

export const getValueByPath = function(object, prop) {
  prop = prop || ''
  const paths = prop.split('.')
  let current = object
  let result = null
  for (let i = 0, j = paths.length; i < j; i++) {
    const path = paths[i]
    if (!current) break

    if (i === j - 1) {
      result = current[path]
      break
    }
    current = current[path]
  }
  return result
}

